/**
 * Mac vs. everything-else detection for keyboard-shortcut labels (⌘K vs
 * Ctrl+K). `navigator.userAgentData` is the modern, non-deprecated source
 * where available (Chromium); `navigator.platform` is deprecated but still
 * the only signal in Safari/Firefox, so it stays as a fallback rather than
 * being dropped.
 */
export const isMacPlatform = () => {
  if (typeof navigator === "undefined") return false;
  const platform = navigator.userAgentData?.platform || navigator.platform || navigator.userAgent || "";
  return /Mac|iPhone|iPad|iPod/i.test(platform);
};
